export const environment = {
  production: true,
  stage: 'prod',
};
